
// ##### UTILITY FUNCTIONS #####

// Keeps only the rows belonging to the given brand ('all' keeps everything).
// Rows without a brand are ABuss ones
export function filterByBrand(rows, brand) {
    if(!brand || brand === 'all') return rows;
    return rows.filter(row => (row["query_brand"] || 'abuss') === brand);
}

// Returns date in '30.01.2024'
export function formatDate(date) {
    return `${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()}.${(date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1}.${date.getFullYear()}`;
}

export function prettifyTimestamp(UNIX_timestamp) {
    const d = new Date(UNIX_timestamp * 1000);
    return formatDate(d) + ' ' + d.toLocaleTimeString('et-EE').substring(0, 5);
}

export function formatDuration(minutes) {
    if(minutes == 0) return "-";
    // formats by minutes, hours, days
    const remainder = minutes % 60;
    const hours = Math.floor((minutes - remainder) / 60) % 24;
    const days = Math.floor((minutes - remainder) / 60 / 24);

    let strs = [];
    if(days != 0) strs.push(days + " p");
    if(hours != 0) strs.push(hours + " h");
    if(remainder != 0) strs.push(remainder + " min");
    return strs.join(" ");
}

export function sameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
}

// ##### DISPLAY FUNCTIONS #####
// These output text which should be displayed immmediately,
// and does not need further processing

export function displayDepart(row) {
    if(row["query_start"]) {
        return prettifyTimestamp(row["query_start"]);
    } else {
        const route = JSON.parse(row["query_route"]);
        return prettifyTimestamp(route[0]["depart"]);
    }
}

export function sortDepart(a, b) {
    const aTime = a["query_start"] || JSON.parse(a["query_route"])[0]["depart"];
    const bTime = b["query_start"] || JSON.parse(b["query_route"])[0]["depart"];
    console.log("db40: a:", aTime, "b:", bTime);
    return aTime - bTime;
}

export function displayPrettyRoute(row) {
    return JSON.parse(row["query_route"]).map(route => route["city_name"]).join(" - ");
}

export function calcRouteStops(row) {
    const route = JSON.parse(row["query_route"]);

    if(!route[0]["depart"]) {
        // Old version, has 'duration' field
        const minutes = route
        .reduce(
            (prev, val, index, arr) => {
                return prev + (val["duration"] || 0);
            },
            0
        );

        return minutes;
    } else {
        // New version, has 'depart' field

        // Sum minutes between depart and arrive times to get total stop time
        const minutes = route
            .reduce(
                (prev, val, index, arr) => {
                    if(index == 0) return prev;
                    if(index == arr.length - 1) return prev;
                    const newval = val["arrive"]
                        ? (prev + Math.floor((val["depart"] - val["arrive"]) / 60))
                        : 0;
                    return newval || 0;
                },
                0
            );

        return minutes;
    }
}

export function displayRouteStops(row) {
    return formatDuration(calcRouteStops(row));
}

export function displayDistance(row) {
    return row["query_distance"] ? row["query_distance"].toFixed(0) + " km" : "-";
}

export function displayPrice(val) {
    return (+val).toFixed(2) + " €";
}

export function displayDriver(row) {
    return row["driver_id"] ? ( row["driver_firstname"] ) : "-";
}

// All drivers of a job (primary + extras) with their confirmation statuses.
// The JSON fields arrive as strings in shownData rows but as parsed arrays in
// knownData rows, so handle both.
export function getJobDriversWithStatus(row) {
    const parse = (val) => (typeof val === "string" ? JSON.parse(val) : (val || []));

    const confirmations = parse(row["driver_confirmations"]);
    const statusOf = (driverID) => {
        const confirmation = confirmations.find((confirmation) => confirmation.driver_id === driverID);
        if(confirmation) return confirmation.status;
        // Jobs from before per-driver confirmations only have the job-level
        // status, which belongs to the primary driver
        if(driverID && driverID === row["job_driver"]) return row["job_confirmation_status"];
        return "waiting";
    };

    const drivers = [];
    if(row["driver_id"]) {
        drivers.push({ id: row["driver_id"], name: row["driver_firstname"], status: statusOf(row["driver_id"]) });
    }

    const extraIDs = parse(row["extra_driver_ids"]);
    const extraNames = parse(row["extra_driver_names"]);
    extraIDs.forEach((id, index) => {
        drivers.push({ id, name: extraNames[index], status: statusOf(id) });
    });

    return drivers;
}

export function displayType(row) {
    switch(row["type"]) {
        case 'job': return "Töö";
        case 'query': return "Päring";
        case 'confirmedQuery': return "Kinnitatud pakkumine";
        case 'answeredQuery': return "Vastatud päring";
        default: return "-";
    };
}